<template>
  <div class="searchPage">
    <div class="search_wrapper flex-between">
      <div class="search_box">
        <van-field v-model="keyword" placeholder="请输入企业名称" @keyup.enter="handleSearch" />
      </div>
      <div class="search_btn" @click="handleSearch">查找企业</div>
    </div>
    <router-view :keyword="resultKey"></router-view>
  </div>
</template>
<script>
export default {
  name: "searchCompany",
  data() {
    return {
      keyword: "",
      resultKey: ''
    };
  },
  methods: {
    handleSearch() {
      this.resultKey = this.keyword
    }
  }
};
</script>
<style lang="less" scoped>
.searchPage {
  padding-bottom: 240px;
  .search_wrapper {
    padding: 40px 40px 30px;
    margin-bottom: 30px;
    .search_box {
      height: 60px;
      border-radius: 35px;
      background: #f0f0f0;
      padding: 0 40px;
      box-sizing: border-box;
      flex: 1;
      font-size: 20px;
      /deep/ .van-cell {
        background: none;
        padding: 0;
        height: 100%;
      }
      /deep/ .van-field__body {
        height: 100%;
        font-size: 12px;
      }
    }
    .search_btn {
      height: 60px;
      line-height: 60px;
      background: #f40728;
      font-size: 20px;
      color: #fff;
      border-radius: 45px;
      padding: 0 40px;
      flex-shrink: 0;
      margin-left: 30px;
    }
  }
}
</style>